<template>
  <div>
    <ApuracaoPaginador
      v-if="totalPaginas > 1"
      :pagina="pagina"
      :total="totalPaginas"
      @mudar="mudarPagina"
    />
    <v-data-table
      :headers="headers"
      :items="rows"
      hide-default-footer
      disable-pagination
      dense
      style="white-space: nowrap"
    >
      <template v-slot:body>
        <tbody v-if="gruposPagina.length">
          <template v-for="(grupo, gi) in gruposPagina">
            <tr
              v-for="(row, ri) in grupo.rows"
              :key="`${gi}-${ri}`"
              :style="ri === 0 && gi > 0 ? 'border-top: 2px solid rgba(42,87,136,0.12)' : ''"
            >
              <td
                v-if="ri === 0"
                :rowspan="grupo.rows.length"
                style="vertical-align: middle; padding: 4px 10px; border-right: 1px solid rgba(0,0,0,0.08); min-width: 100px; max-width: 140px"
              >
                <div class="caption font-weight-medium d-block">{{ (row.apelido || row.nome_empresa || '').toUpperCase() }}</div>
              </td>
              <td
                v-if="ri === 0"
                :rowspan="grupo.rows.length"
                style="vertical-align: middle; padding: 4px 10px; border-right: 2px solid rgba(42,87,136,0.15); min-width: 130px; max-width: 200px"
              >
                <div class="caption font-weight-bold d-block">{{ row.colaborador }}</div>
                <div class="caption grey--text text--darken-1 d-block" style="font-size: 10px">{{ row.funcao }}</div>
              </td>

              <td style="padding: 2px 10px">
                <div v-if="ehLinhaComissao(row)" class="caption font-weight-medium" style="color: #1976d2">
                  <v-icon x-small color="primary" class="mr-1">mdi-percent</v-icon>{{ rotuloComissao(row) }}
                </div>
                <BaseLineTableCodDescription v-else :cod="row.id_produto" :description="row.produto" />
              </td>

              <!-- Na linha de comissao, meta e realizado sao os DO PARTICIPANTE
                   (a soma dos itens contra a meta individual) — e o par que
                   decidiu o pagamento daquela linha. -->
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ formatarValor(row) }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ formatarRealizado(row) }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ ehLinhaComissao(row) ? "—" : formatarBonus(row) }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ row.valor_bonus_apurado | BrazilianCurrency }}
              </td>
              <td class="text-center" style="padding: 2px 10px">
                <span v-if="ehLinhaComissao(row)">—</span>
                <IconGanhou v-else :ganhou="row.ganhou_item" />
              </td>
              <td class="text-center" style="padding: 2px 10px">
                <IconGanhou :ganhou="row.ganhou_meta" />
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                <span :class="statusPagamento(row).valorClass">{{ row.valor_bonus_pagamento | BrazilianCurrency }}</span>
                <v-chip
                  v-if="statusPagamento(row).chip"
                  x-small
                  :color="statusPagamento(row).chip.color"
                  :class="['ml-1 font-weight-bold', statusPagamento(row).chip.textColor]"
                >{{ statusPagamento(row).chip.text }}</v-chip>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="headers.length" class="text-center grey--text py-4">Sem dados</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import currencyMixin from "@/mixins/currencyMixin";
import apuracaoTabelaMixin from "@/mixins/apuracaoTabelaMixin";
import { ehLinhaComissao } from "@/mixins/apuracaoTipoMixin";
import BaseLineTableCodDescription from "@/components/shared/BaseLineTableCodDescription";

export default {
  name: "ApuracaoTabelaModelo",

  components: {
    BaseLineTableCodDescription,
    ApuracaoPaginador: () => import("./ApuracaoPaginador"),
    IconGanhou: () => import("@/components/shared/icons/Ganhou")
  },

  mixins: [currencyMixin, apuracaoTabelaMixin],

  data() {
    return {
      headers: [
        { text: "Empresa",       value: "empresa",               sortable: false },
        { text: "Colaborador",   value: "colaborador",            sortable: false },
        { text: "Modelo",        value: "produto",                sortable: true  },
        { text: "V. Meta",       value: "valor_meta",             sortable: true  },
        { text: "Realizado",     value: "valor_realizado",        sortable: true  },
        { text: "Bônus Unit.",   value: "valor_bonus",            sortable: true  },
        { text: "Bônus Apurado", value: "valor_bonus_apurado",    sortable: true  },
        { text: "Item",          value: "ganhou_item",            sortable: false },
        { text: "Meta",          value: "ganhou_meta",            sortable: false },
        { text: "Bônus Pago",    value: "valor_bonus_pagamento",  sortable: true  }
      ]
    };
  },

  methods: {
    ehLinhaComissao,

    formatarBonus(row) {
      return this.$options.filters.BrazilianCurrency(row.valor_bonus);
    },

    rotuloComissao(row) {
      const pct = parseFloat(row.percentual_comissao);
      return pct > 0 ? `Comissão P2 (${pct.toLocaleString("pt-BR")}%)` : "Comissão P2";
    }
  }
};
</script>
